import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import OrderPage from "./pages/OrderPage";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import FindOrder from "./pages/FindOrder";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import { AuthProvider } from "./context/AuthContext";
import Account from "./pages/Account";
import ReviewPage from "./pages/ReviewPage";
import { AuthCallback } from "./components/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Google sign-in returns with #session_id=... — handle it before any route renders
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/order/:id" element={<OrderPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/find-order" element={<FindOrder />} />
      <Route path="/account" element={<Account />} />
      <Route path="/review/:id" element={<ReviewPage />} />
      <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
      <Route path="/admin/forgot" element={<ForgotPassword />} />
      <Route path="/admin/reset" element={<ResetPassword />} />
      <Route path="/admin" element={<AuthProvider><AdminDashboard /></AuthProvider>} />
    </Routes>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </>
  );
}

export default App;
